import { observer } from 'mobx-react-lite';
import { ContentHead } from '../../lib/components';
import { ContentBox } from '../../lib/components/compound/pages/contentBox';
import { useTranslation } from 'react-i18next';
import { BenefitSetOverviewTable } from '../../lib/components/tables/benefitSet/benefitSet';
import { AddButton } from '../company/settings/shared/addButton';
import { PlusIcon } from '../../lib/icons';
import { useNavigate } from 'react-router';
import { CardOnboardingNotice } from '../../lib/components/compound/pxtraCardOnboarding';

export const BenefitSets = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickCreate = () => navigate('/actions/benefit-set/create_benefit_set/1');

  return (
    <ContentBox
      headComponent={
        <ContentHead
          headline={t('benefitSet:benefitSet_other')}
          subtitle={t('benefitSet:subtitle')}
          showActions={true}
          renderActions={() => (
            <AddButton
              text={t('benefitSet:createNewSet')}
              startIcon={<PlusIcon />}
              onClick={handleClickCreate}
            />
          )}
        />
      }
    >
      <CardOnboardingNotice />
      <BenefitSetOverviewTable />
    </ContentBox>
  );
});
